import { ActionStatus } from '@common/constants/shared';
import { MetadataAction } from '@common/types/action';
import { get } from 'lodash';
import { ActionResponse } from '../excuteAction';

export const deleteObject: (
  action: any,
  metadata: MetadataAction
) => Promise<ActionResponse> = async (
  action: any,
  metadata: MetadataAction
) => {
  const { messages } = metadata;
  if (action.status === ActionStatus.SUCCESS) {
    return {
      status: ActionStatus.SUCCESS,
      message: messages['database_deleted_record'],
      recordDeleted: action.response,
    };
  }

  return {
    status: ActionStatus.FAILED,
    message: get(action, 'error.message'),
  };
};
